import {labDialogCopy} from './locales/lab-dialog.js';

const bindings=new WeakMap();
const focusSelector='button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]';
const attributes=['role','aria-modal','aria-labelledby','aria-describedby','tabindex'];

// Inert siblings at each ancestor level, never an ancestor of the experiment.
export function labBackgroundElements(lab,body){
 const elements=[];let branch=lab;
 while(branch?.parentElement){
  const parent=branch.parentElement;
  for(const sibling of parent.children)if(sibling!==branch&&sibling.tagName?.toLowerCase()!=='dialog')elements.push(sibling);
  if(parent===body)break;
  branch=parent;
 }
 return elements;
}

export function bindLabDialog(lab,{language='en',onClose}={}){
 if(!lab)throw new TypeError('The experiment section is required');
 bindings.get(lab)?.dispose();
 const doc=lab.ownerDocument,win=doc.defaultView,c=labDialogCopy[language==='ja'?'ja':'en'];
 const toolbar=doc.createElement('div');toolbar.className='lab-dialog-toolbar';
 const heading=doc.createElement('div'),title=doc.createElement('h2'),description=doc.createElement('p');
 title.id='lab-dialog-title';title.textContent=c.title;description.id='lab-dialog-description';description.textContent=c.description;
 heading.append(title,description);
 const closeButton=doc.createElement('button');closeButton.type='button';closeButton.className='lab-dialog-close';closeButton.textContent=c.close;closeButton.title=c.shortcut;
 toolbar.append(heading,closeButton);lab.prepend(toolbar);
 let opened=false,disposed=false,origin=null,scroll=null,placeholder=null,inertState=[],savedAttributes=[],styles=[];
 const nativeDialogOpen=()=>!!doc.querySelector('dialog[open]');
 const focusables=()=>[...lab.querySelectorAll(focusSelector)].filter(el=>el.tabIndex>=0&&!el.disabled&&!el.closest('[hidden],[inert]')&&el.getClientRects().length);
 const focusFirst=()=>{const first=focusables()[0]||lab;first.focus({preventScroll:true});};
 function restoreAttribute(el,name,value){if(value===null)el.removeAttribute(name);else el.setAttribute(name,value);}
 function open(){
  if(disposed||opened)return;
  origin=doc.activeElement;scroll={left:win.scrollX,top:win.scrollY};
  savedAttributes=attributes.map(name=>[name,lab.getAttribute(name)]);
  styles=['overflow','padding-right'].map(name=>[name,doc.body.style.getPropertyValue(name),doc.body.style.getPropertyPriority(name)]);
  placeholder=doc.createElement('div');placeholder.className='lab-dialog-placeholder';placeholder.setAttribute('aria-hidden','true');placeholder.style.height=lab.getBoundingClientRect().height+'px';lab.before(placeholder);
  const scrollbar=Math.max(0,win.innerWidth-doc.documentElement.clientWidth);
  if(scrollbar){const padding=Number.parseFloat(win.getComputedStyle(doc.body).paddingRight)||0;doc.body.style.setProperty('padding-right',padding+scrollbar+'px');}
  doc.body.style.setProperty('overflow','hidden');
  inertState=labBackgroundElements(lab,doc.body).map(el=>[el,el.getAttribute('inert')]);
  inertState.forEach(([el])=>el.setAttribute('inert',''));
  lab.setAttribute('role','dialog');lab.setAttribute('aria-modal','true');lab.setAttribute('aria-labelledby',title.id);lab.setAttribute('aria-describedby',description.id);lab.setAttribute('tabindex','-1');
  opened=true;lab.classList.add('lab-dialog-open');lab.scrollTop=0;closeButton.focus({preventScroll:true});
 }
 function close({restoreFocus=true,restoreScroll=true,reason='close',notify=true}={}){
  if(!opened)return;
  opened=false;lab.classList.remove('lab-dialog-open');
  inertState.forEach(([el,value])=>restoreAttribute(el,'inert',value));inertState=[];
  savedAttributes.forEach(([name,value])=>restoreAttribute(lab,name,value));
  styles.forEach(([name,value,priority])=>{if(value)doc.body.style.setProperty(name,value,priority);else doc.body.style.removeProperty(name);});
  placeholder?.remove();placeholder=null;if(restoreScroll)win.scrollTo({...scroll,behavior:'instant'});
  if(restoreFocus&&origin?.isConnected&&!origin.closest('[inert]'))origin.focus({preventScroll:true});
  if(notify)onClose?.({reason,origin,scroll:{...scroll}});
 }
 function keydown(event){
  if(!opened||nativeDialogOpen())return;
  if(event.key==='Escape'){event.preventDefault();event.stopPropagation();close({reason:'escape'});return;}
  if(event.key!=='Tab')return;
  const nodes=focusables(),first=nodes[0],last=nodes.at(-1);
  if(!nodes.length){event.preventDefault();lab.focus({preventScroll:true});return;}
  if(event.shiftKey&&(doc.activeElement===first||!lab.contains(doc.activeElement))){event.preventDefault();last.focus({preventScroll:true});}
  else if(!event.shiftKey&&(doc.activeElement===last||!lab.contains(doc.activeElement))){event.preventDefault();first.focus({preventScroll:true});}
 }
 function focusin(event){if(opened&&!nativeDialogOpen()&&!lab.contains(event.target))focusFirst();}
 const clickClose=()=>close({reason:'button'});
 closeButton.addEventListener('click',clickClose);doc.addEventListener('keydown',keydown);doc.addEventListener('focusin',focusin);
 const controller={open,close,get isOpen(){return opened;},dispose(){if(disposed)return;close({notify:false});disposed=true;closeButton.removeEventListener('click',clickClose);doc.removeEventListener('keydown',keydown);doc.removeEventListener('focusin',focusin);toolbar.remove();if(bindings.get(lab)===controller)bindings.delete(lab);}};
 bindings.set(lab,controller);return controller;
}
